export const format = (v: number | undefined, minDigits = 2, maxDigits = 2) =>
    v
        ? v.toLocaleString(undefined, {
              minimumFractionDigits: minDigits,
              maximumFractionDigits: maxDigits,
          })
        : '-';

export const formatBaht = (value: number, minDigits = 2, maxDigits = 2) =>
    Intl.NumberFormat('th-TH', {
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits,
    }).format(value);
